<section
  class="balance-charge-breakdown"
  data-testid="visit-row-breakdown"
  [id]="panelId()"
  [attr.aria-label]="'balance.review.breakdown.title' | translate"
>
  @if (showHeader()) {
    <header class="balance-charge-breakdown__header">
      <span class="balance-charge-breakdown__title">{{ 'balance.review.breakdown.title' | translate }}</span>
      <span class="balance-charge-breakdown__count">
        {{ (hasSearchQuery() ? 'balance.review.breakdown.filtered-count' : 'balance.review.breakdown.code-count') | translate: { count: filteredChargeCount(), total: chargeCount() } }}
      </span>
    </header>
  }

  <div class="balance-charge-breakdown__search">
    <label [for]="searchId()">{{ 'balance.review.breakdown.search-label' | translate }}</label>
    <div class="balance-charge-breakdown__search-control">
      <mat-icon aria-hidden="true">search</mat-icon>
      <input
        type="text"
        autocomplete="off"
        data-testid="visit-row-breakdown-search"
        [id]="searchId()"
        [value]="searchQuery()"
        [attr.aria-controls]="resultsId()"
        [placeholder]="'balance.review.breakdown.search-placeholder' | translate"
        (input)="onSearch($event)"
      >
      @if (searchQuery()) {
        <button
          mat-icon-button
          type="button"
          data-testid="visit-row-breakdown-search-clear"
          [attr.aria-label]="'balance.review.breakdown.clear-search' | translate"
          (click)="clearSearch()"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>
  </div>

  @if (filteredChargeCount() > 0) {
    <div class="balance-charge-breakdown__results" [id]="resultsId()">
      <table class="balance-charge-breakdown__price-list">
        <thead>
          <tr>
            <th scope="col">{{ 'balance.review.breakdown.description' | translate }}</th>
            <th class="balance-charge-breakdown__cpt" scope="col">{{ 'balance.review.breakdown.cpt' | translate }}</th>
            <th class="balance-charge-breakdown__quantity" scope="col">{{ 'balance.review.breakdown.quantity' | translate }}</th>
            <th class="balance-charge-breakdown__money" scope="col">{{ 'balance.review.breakdown.price' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (row of visibleRows(); track row.key) {
            <tr>
              <td data-testid="visit-row-breakdown-description">{{ row.description }}</td>
              <td class="balance-charge-breakdown__cpt" data-testid="visit-row-breakdown-cpt">{{ row.cptCode }}</td>
              <td class="balance-charge-breakdown__quantity" data-testid="visit-row-breakdown-quantity">{{ row.quantity }}</td>
              @if (row.price === null) {
                <td class="balance-charge-breakdown__money balance-charge-breakdown__unavailable-price">
                  <span aria-hidden="true">&mdash;</span>
                  <span class="balance-charge-breakdown__visually-hidden">{{ 'balance.review.breakdown.unavailable' | translate }}</span>
                </td>
              } @else {
                <td class="balance-charge-breakdown__money" data-testid="visit-row-breakdown-price">{{ row.price | currency }}</td>
              }
            </tr>
          }
        </tbody>
      </table>

      @if (hasVisibleUnpricedRows()) {
        <p class="balance-charge-breakdown__unavailable-key">
          <span aria-hidden="true">&mdash;</span>
          {{ 'balance.review.breakdown.unavailable' | translate }}
        </p>
      }

      @if (pageCount() > 1) {
        <nav class="balance-charge-breakdown__pagination" [attr.aria-label]="'balance.review.breakdown.pagination-label' | translate">
          <span>
            {{ 'balance.review.breakdown.result-range' | translate: { start: resultStart(), end: resultEnd(), total: filteredRows().length } }}
          </span>
          <span class="balance-charge-breakdown__pagination-actions">
            <button
              mat-icon-button
              type="button"
              data-testid="visit-row-breakdown-previous-page"
              [disabled]="currentPage() === 0"
              [attr.aria-label]="'balance.review.breakdown.previous-page' | translate"
              (click)="previousPage()"
            >
              <mat-icon>chevron_left</mat-icon>
            </button>
            <button
              mat-icon-button
              type="button"
              data-testid="visit-row-breakdown-next-page"
              [disabled]="currentPage() === pageCount() - 1"
              [attr.aria-label]="'balance.review.breakdown.next-page' | translate"
              (click)="nextPage()"
            >
              <mat-icon>chevron_right</mat-icon>
            </button>
          </span>
        </nav>
      }
    </div>
  } @else {
    <p class="balance-charge-breakdown__no-results" [id]="resultsId()" data-testid="visit-row-breakdown-no-results">
      {{ 'balance.review.breakdown.no-results' | translate: { query: searchQuery() } }}
    </p>
  }

  <footer class="balance-charge-breakdown__footer">
    <span>{{ 'balance.review.breakdown.total' | translate }}</span>
    <strong data-testid="visit-row-breakdown-total">{{ total() | currency }}</strong>
  </footer>
</section>
